
import { Link } from 'react-router-dom';

export default function AmazonAutomationCTA() {
  return (
    <section className="py-14 md:py-20 bg-gradient-to-br from-[#14B8A6]/5 via-white to-[#14B8A6]/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="grid md:grid-cols-2 gap-0">
            <div className="relative h-[250px] md:h-auto">
              <img
                src="https://public.readdy.ai/ai/img_res/181d6fbf4c2a9c47054f79a1a0f12a0c.jpg"
                alt="Amazon自動化"
                className="absolute inset-0 w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent"></div>
            </div>
            
            <div className="p-6 md:p-12 flex flex-col justify-center">
              <div className="inline-flex items-center gap-1.5 md:gap-2 bg-[#14B8A6]/10 text-[#14B8A6] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold mb-4 md:mb-6 w-fit">
                <i className="ri-amazon-line text-base md:text-lg"></i>
                <span>詳細ガイド</span>
              </div>
              
              <h2 className="text-2xl md:text-3xl font-black text-gray-900 mb-3 md:mb-4 leading-tight">
                Amazon自動化の<br />
                <span className="text-[#14B8A6]">本質を理解する</span>
              </h2>
              
              <p className="text-xs md:text-base text-gray-600 mb-4 md:mb-6 leading-relaxed">
                商品リサーチから利益分析まで、Amazon販売における8つの業務を自動化する具体的な方法を詳しく解説。月商100万から1000万超まで対応するレベル別戦略をご紹介します。
              </p>
              
              <ul className="space-y-2 md:space-y-3 mb-5 md:mb-8">
                <li className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#14B8A6]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-[#14B8A6] text-xs md:text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-xs md:text-sm"><strong>8つの業務自動化</strong>の詳細解説</span>
                </li>
                <li className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#14B8A6]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-[#14B8A6] text-xs md:text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-xs md:text-sm"><strong>レベル別戦略</strong>で段階的に実装</span>
                </li>
                <li className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#14B8A6]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-[#14B8A6] text-xs md:text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-xs md:text-sm"><strong>技術スタック</strong>と実装方法</span>
                </li>
              </ul>
              
              <Link
                to="/amazon-automation"
                className="inline-flex items-center justify-center gap-2 bg-[#14B8A6] text-white px-6 md:px-8 py-3 md:py-4 rounded-lg font-bold text-sm md:text-base hover:bg-[#0F9B8E] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer group"
              >
                <span>完全ガイドを読む</span>
                <i className="ri-arrow-right-line text-lg md:text-xl group-hover:translate-x-1 transition-transform"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
